import React from 'react'
import styles from './styles.module.css'

export const ExampleComponent = ({ text }) => {
  return <div className={styles.test}>Example Component1: {text}</div>
}

export { MUITable } from './components/MUITable'
